import { AbstractControl, ValidatorFn } from "@angular/forms";

export const matchValidator = (
  controlName: string,
  matchingControlName: string
): ValidatorFn => {
  return (abstractControl: AbstractControl) => {
    const control = abstractControl.get(controlName);
    const matchingControl = abstractControl.get(matchingControlName);

    if (
      matchingControl.errors &&
      !matchingControl.errors["confirmedPasswordMatchValidator"]
    ) {
      return null;
    }

    if (control.value !== matchingControl.value) {
      const error = {
        confirmedPasswordMatchValidator: "Passwords do not match.",
      };
      matchingControl.setErrors(error);
      return error;
    } else {
      matchingControl.setErrors(null);
      return null;
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/_directives/passwords-match.validator.ts